function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.767 14.731h.009l.015.005s.287.083.287.292a.214.214 0 01-.164.052.535.535 0 01-.29-.164.492.492 0 10-.732.656 1.5 1.5 0 001.022.492 1.074 1.074 0 001.148-1.04 1.323 1.323 0 00-.991-1.229h-.01c-.039-.012-.31-.131-.31-.268 0-.038.071-.082.164-.082a.536.536 0 01.289.164.492.492 0 00.732-.656 1.5 1.5 0 00-1.022-.492 1.1 1.1 0 00-1.148 1.065 1.35 1.35 0 001.001 1.205zM10.756 15.99a.491.491 0 00.678-.156l.4-.644.4.644a.492.492 0 00.834-.521l-.657-1.051.657-1.051a.492.492 0 10-.834-.521l-.4.644-.4-.644a.492.492 0 10-.834.521l.657 1.051-.657 1.051a.492.492 0 00.156.677z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.972 16.065h1.311a.492.492 0 100-.983h-.82v-2.131a.492.492 0 00-.984 0v2.623a.491.491 0 00.493.491z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.886 11.147H9.71a.491.491 0 00-.492.492v5.246a.491.491 0 00.492.492h9.18a.491.491 0 00.492-.492v-5.246a.491.491 0 00-.496-.492zm-.492 5.246h-8.2V12.13h8.2z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.263 18.033a.492.492 0 00-.492.492v.492H2.984V.984h7.541v4.754a.491.491 0 00.492.492h4.755v3.771a.492.492 0 10.984 0V5.739a.488.488 0 00-.054-.221l-.01-.019a.488.488 0 00-.084-.112L11.366.145a.492.492 0 00-.1-.078l-.027-.014A.476.476 0 0011.12.01h-.009a.53.53 0 00-.089-.009H2.831a.826.826 0 00-.825.825v18.35a.826.826 0 00.825.825H15.94a.821.821 0 00.82-.82v-.655a.492.492 0 00-.497-.493zM11.508 5.246V1.679l3.567 3.567z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgFileExcel = function SvgFileExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFileExcel, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/FileExcel.93c3c9e1.svg";
export { ForwardRef as ReactComponent };